import { gql } from '@apollo/client';
import { DealFragment } from './DealFragment';
/**
 * Client-only deal fields (not exposed on the public GraphQL schema).
 * @fragment DealConfiguratorFragment
 * @since 1.0.0
 */
export const DealConfiguratorFragment = gql `
  fragment DealConfiguratorFragment on Deal {
    ...DealFragment
    internalNotes
    payments {
      id
      infos
    }
  }

  ${DealFragment}
`;
